import React from 'react'

function Page404() {
    return (
        <div>
            looks Like URL is broken
        </div>
    )
}

export default Page404
